<template>
  <div class="events">
    <b-card no-body id="myeventsCard" class="p-3">
      <b-card-header>
        <div class="row mb-1">
          <div class="col-12 mb-2 mb-md-0">
            <div class="btn-group">
              <button
                type="button"
                class="btn btn-bumblebee btn-tab btn-all"
                :class="{
                  active: onlineFilter === '',
                  'btn-doomyoga btn-doomyoga-secondary': client_name == 'DY',
                  'btn-mid btn-mid-secondary': client_name == 'MID',
                }"
                @click.prevent="onlineFilter = ''"
              >
                All
              </button>
              <button
                v-for="btnFilter in filter_buttons"
                :key="btnFilter.value"
                type="button"
                class="btn btn-bumblebee btn-tab"
                :class="{
                  active: onlineFilter === btnFilter.value,
                  'btn-doomyoga btn-doomyoga-secondary': client_name == 'DY',
                  'btn-mid btn-mid-secondary': client_name == 'MID',
                }"
                @click.prevent="onlineFilter = btnFilter.value"
              >
                {{ btnFilter.name }}
              </button>
            </div>
          </div>
        </div></b-card-header
      >
      <b-card-body class="p-md-3 p-0 pt-3">
        <dataset
          v-slot="{ ds }"
          :ds-data="events"
          :ds-filter-fields="{
            type: onlineFilter,
            name: startsWithFilter,
          }"
          :ds-search-in="['name', 'type', 'address', 'pricing']"
          :ds-search-as="{}"
          :datasetI18n="datasetI18n"
        >
          <div
            class="row mb-2"
            :data-page-count="ds.dsPagecount"
            dsShowEntries="5"
          >
            <div class="col-md-8">
              <b-input-group
                class=""
                v-bind:class="{
                  'input-group-search-doomyoga': client_name == 'DY',
                  'input-group-search-mid': client_name == 'MID',
                }"
              >
                <template #prepend>
                  <font-awesome-icon
                    icon="fa-solid fa-magnifying-glass"
                  />
                </template>
                <dataset-search
                  ds-search-placeholder="Search"
                  v-bind:class="{
                    'form-control-doomyoga': client_name == 'DY',
                    'form-control-mid': client_name == 'MID',
                  }"
              /></b-input-group>
            </div>
            <div class="col-md-2 addButtonContainerDiv">
              <router-link
                v-if="client_name == 'DY'"
                to="/doom_yoga/add_event"
                id=""
                class="
                  btn btn-bumblebee btn-doomyoga btn-filter btn-doomyoga-primary
                  m-0
                "
              >
                + Add new
              </router-link>
              <router-link
                v-if="client_name == 'MID'"
                to="/my_irish_date/add_event"
                id=""
                class="btn btn-bumblebee btn-mid btn-filter btn-mid-primary m-0"
              >
                + Create new event
              </router-link>
            </div>
          </div>
          <dataset-show class="d-none" :ds-show-entries="5" />
          <!-- end row of search and add event link-->
          <b-row>
            <b-col>
              <h5
                v-bind:class="{
                  'card-subtitle-doom-yoga': client_name == 'DY',
                  'card-subtitle-irish-date': client_name == 'MID',
                }"
              >
                {{ sub_title }}
              </h5>
            </b-col>
          </b-row>
          <div class="row">
            <div class="col-md-12">
              <dataset-item class="row mb-3">
                <template #default="{ row }">
                  <div class="col-12">
                    <div
                      class="card card-transparent-background my-2"
                      v-bind:class="{
                        'doom-yoga-border-div card-event-doomyoga':
                          client_name == 'DY',
                        'mid-border-div card-event-mid': client_name == 'MID',
                      }"
                    >
                      <div class="card-body pt-3 pb-2 px-3">
                        <div class="row px-3">
                          <div
                            class="
                              col-md-2
                              p-0
                              text-md-left text-center
                              event-img-container
                              mb-2 mb-md-0
                            "
                          >
                            <img
                              v-if="
                                row.cover.path != null && row.cover.path != ''
                              "
                              :src="row.cover.path"
                              alt="yoga icon"
                              class="event-img"
                            />
                            <img
                              v-else-if="
                                (row.cover.path == null ||
                                  row.cover.path == '') &&
                                client_name == 'DY'
                              "
                              src="@/assets/images/doom-yoga/event_img.png"
                              alt="yoga icon"
                              class="event-img"
                            />
                            <img
                              v-else-if="
                                (row.cover.path == null ||
                                  row.cover.path == '') &&
                                client_name == 'MID'
                              "
                              src="@/assets/images/my-irish-date/logo.png"
                              alt="mid icon"
                              class="event-img"
                            />
                          </div>
                          <!-- end col - event image-->
                          <div class="col-md-6 px-0">
                            <h2 class="eventNameH2">
                              {{ row.name }}
                            </h2>
                            <h4 class="eventMaxParticipantH4">
                              Max participant: {{ row.capacity }}
                            </h4>
                            <h4 class="eventLocationH4">
                              {{ row.address }}
                            </h4>
                            <!-- <router-link
                              v-if="
                                client_name == 'DY' &&
                                row.type == 'class' &&
                                !row.has_sessions
                              "
                              :to="'/doom_yoga/edit_event/class/' + row.id"
                              class="card-link eventLink"
                            >
                              <span class="mx-1 my-auto">
                                <font-awesome-icon
                                  icon="fa-solid fa-exclamation-circle"
                                  size="lg"
                                />
                              </span>
                              <span class="span-grey"
                                >No upcoming sessions.</span
                              >
                              Add Sessions
                              <span class="mx-1 my-auto">
                                <font-awesome-icon
                                  icon="fa-solid fa-arrow-right"
                                  size="md"
                                  class="align-middle"
                                />
                              </span>
                            </router-link> -->
                            <router-link
                              v-if="client_name == 'DY'"
                              to="/doom_yoga/calendar"
                              class="card-link eventLink"
                            >
                              Show Schedule
                              <span class="mx-1 my-auto">
                                <font-awesome-icon
                                  icon="fa-solid fa-arrow-right"
                                  class="align-middle"
                                />
                              </span>
                            </router-link>
                            <router-link
                              v-else-if="client_name == 'MID'"
                              to="/my_irish_date/calendar"
                              class="card-link eventLink"
                            >
                              Show Schedule
                              <span class="mx-1 my-auto">
                                <font-awesome-icon
                                  icon="fa-solid fa-arrow-right"
                                  class="align-middle"
                                />
                              </span>
                            </router-link>
                          </div>
                          <div class="col-md-3 text-md-left text-right">
                            <label class="eventLabel"> Pricing </label>
                            <p class="eventPricingP" v-if="row.price != null">
                              {{ currency }}{{ row.price }} per participant
                              <!--per participant-->
                            </p>
                            <p class="eventPricingP" v-else>
                              Free
                              <!--per participant-->
                            </p>
                          </div>
                          <!--end price col -->
                          <div class="col-md-1 text-md-right text-center">
                            <!-- <b-button-group vertical size="sm" class="eventButtonGroupAction my-0"> -->
                            <b-button
                              v-if="row.is_hidden == 0"
                              variant="action"
                              class="d-block mb-1"
                              @click="hideEvent(row.id)"
                            >
                              <img
                                :src="
                                  getImgUrl(images_folder + '/not-view-icon')
                                "
                                alt="hide icon"
                                width="100%"
                            /></b-button>
                            <b-button
                              v-if="row.is_hidden == 1"
                              variant="action"
                              class="d-block mb-1"
                              @click="displayEvent(row.id)"
                            >
                              <img
                                :src="getImgUrl(images_folder + '/view-icon')"
                                alt="view icon"
                                width="100%"
                            /></b-button>
                            <b-button
                              variant="action"
                              class="d-block mb-1"
                              @click="editEvent(row.id, row.type)"
                              ><img
                                :src="getImgUrl(images_folder + '/edit-icon')"
                                alt="edit icon"
                                width="100%"
                            /></b-button>
                            <!-- <router-link
                              to="/my_irish_date/calendar"
                              class="btn-action d-block mb-1"
                            >
                             <img
                                :src="getImgUrl(images_folder + '/edit-icon')"
                                alt="edit icon"
                                width="100%"
                            />
                            </router-link> -->
                            <b-button
                              variant="action"
                              class="d-block mb-1"
                              @click="deleteEvent(row.id)"
                              ><img
                                :src="getImgUrl(images_folder + '/delete-icon')"
                                alt="delete icon"
                                width="100%"
                            /></b-button>
                            <!-- </b-button-group> -->
                          </div>
                          <!--end actions col div-->
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <template #noDataFound>
                  <div class="col-md-12 pt-2">
                    <p
                      class="text-center datasetNoFoundP"
                      v-bind:class="{
                        noDataFoundDY: client_name == 'DY',
                        noDataFoundMID: client_name == 'MID',
                      }"
                    >
                      No events found
                    </p>
                  </div>
                </template>
              </dataset-item>
            </div>
          </div>
          <div
            class="
              d-flex
              flex-md-row flex-column
              justify-content-between
              align-items-center
            "
          >
            <dataset-info
              class="mb-2 datasetInfo"
              v-bind:class="{
                datasetInfoDY: client_name == 'DY',
                datasetInfoMID: client_name == 'MID',
              }"
            />
            <dataset-pager
              v-bind:class="{
                datasetPagerDY: client_name == 'DY',
                datasetPagerMID: client_name == 'MID',
              }"
            />
          </div>
        </dataset>
      </b-card-body>
    </b-card>
    <!-- delete modal -->
    <b-modal
      id="deleteModal"
      centered
      :modal-class="
        client_name == 'DY' ? 'modal-doom-yoga' : 'modal-irish-date'
      "
    >
      <div class="d-block mb-4">
        <input id="event_id" name="event_id" type="hidden" v-model="event_id" />
        <input id="client" name="client" type="hidden" v-model="client_name" />
        <p
          class="confirmMessageModalP my-4"
          v-bind:class="{
            'message-modal-dy': client_name == 'DY',
            'message-modal-mid': client_name == 'MID',
          }"
        >
          Are you sure to delete this event?
        </p>
      </div>
      <template class="justify-content-center mt-5" #modal-footer>
        <b-row class="justify-content-center w-100">
          <b-col lg="4" md="6" class="text-center">
            <b-button
              type="button"
              :variant="
                client_name == 'MID' ? 'mid-danger' : 'doomyoga-primary'
              "
              class="w-100 btn-bumblebee"
              v-bind:class="{
                'btn-doomyoga  btn-doom-yoga-submit': client_name == 'DY',
                'btn-mid btn-mid-submit': client_name == 'MID',
              }"
              @click="clickConfirmDelete"
            >
              Yes
            </b-button>
          </b-col>

          <b-col lg="4" md="6" class="text-center">
            <b-button
              type="button"
              :variant="
                client_name == 'MID'
                  ? 'mid-secondary-outline'
                  : 'doomyoga-danger-outline'
              "
              class="w-100 btn-bumblebee"
              v-bind:class="{
                'btn-doomyoga btn-doom-yoga-submit': client_name == 'DY',
                'btn-mid btn-mid-submit': client_name == 'MID',
              }"
              @click="closeModalDelete"
            >
              Cancel
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
    <!-- end delete modal-->
    <!-- display event modal-->

    <b-modal
      id="displayModal"
      centered
      :modal-class="
        client_name == 'DY' ? 'modal-doom-yoga' : 'modal-irish-date'
      "
    >
      <div class="d-block mb-4">
        <!-- <b-form-input :id="event_id" :event_id="event_id" v-model="event_id" type="number"></b-form-input> -->
        <input id="event_id" name="event_id" type="hidden" v-model="event_id" />
        <input id="client" name="client" type="hidden" v-model="client_name" />
        <p
          class="confirmMessageModalP my-4"
          v-bind:class="{
            'message-modal-dy': client_name == 'DY',
            'message-modal-mid': client_name == 'MID',
          }"
        >
          Are you sure to display this event?
        </p>
      </div>
      <template class="justify-content-center mt-5" #modal-footer>
        <b-row class="justify-content-center w-100">
          <b-col lg="4" md="6" class="text-center">
            <b-button
              type="button"
              :variant="
                client_name == 'MID' ? 'mid-primary' : 'doomyoga-primary'
              "
              class="w-100 btn-bumblebee"
              v-bind:class="{
                'btn-doomyoga  btn-doom-yoga-submit': client_name == 'DY',
                'btn-mid btn-mid-submit': client_name == 'MID',
              }"
              @click="clickConfirmDisplay"
            >
              Yes
            </b-button>
          </b-col>

          <b-col lg="4" md="6" class="text-center">
            <b-button
              type="button"
              :variant="
                client_name == 'MID'
                  ? 'mid-danger-outline'
                  : 'doomyoga-danger-outline'
              "
              class="w-100 btn-bumblebee"
              v-bind:class="{
                'btn-doomyoga  btn-doom-yoga-submit': client_name == 'DY',
                'btn-mid btn-mid-submit': client_name == 'MID',
              }"
              @click="closeModalDisplay"
            >
              Cancel
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
    <!--end display modal-->
    <!-- hide event modal -->

    <b-modal
      id="hideModal"
      centered
      :modal-class="
        client_name == 'DY' ? 'modal-doom-yoga' : 'modal-irish-date'
      "
    >
      <div class="d-block mb-4">
        <!-- <b-form-input :id="event_id" :event_id="event_id" v-model="event_id" type="number"></b-form-input> -->
        <input id="event_id" name="event_id" type="hidden" v-model="event_id" />
        <input id="client" name="client" type="hidden" v-model="client_name" />
        <p
          class="confirmMessageModalP my-4"
          v-bind:class="{
            'message-modal-dy': client_name == 'DY',
            'message-modal-mid': client_name == 'MID',
          }"
        >
          Are you sure to hide this event?
        </p>
      </div>
      <template class="justify-content-center mt-5" #modal-footer>
        <b-row class="justify-content-center w-100">
          <b-col lg="4" md="6" class="text-center">
            <b-button
              type="button"
              :variant="
                client_name == 'MID' ? 'mid-primary' : 'doomyoga-primary'
              "
              class="w-100 btn-bumblebee"
              v-bind:class="{
                'btn-doomyoga  btn-doom-yoga-submit': client_name == 'DY',
                'btn-mid btn-mid-submit': client_name == 'MID',
              }"
              @click="clickConfirmHide"
            >
              Yes
            </b-button>
          </b-col>

          <b-col lg="4" md="6" class="text-center">
            <b-button
              type="button"
              :variant="
                client_name == 'MID'
                  ? 'mid-danger-outline'
                  : 'doomyoga-danger-outline'
              "
              class="w-100 btn-bumblebee"
              v-bind:class="{
                'btn-doomyoga btn-doom-yoga-submit': client_name == 'DY',
                'btn-mid btn-mid-submit': client_name == 'MID',
              }"
              @click="closeModalHide"
            >
              Cancel
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
    <!--end hide modal-->
  </div>
</template>

<script>
import axios from "axios";
import $ from "jquery";

import {
  filterList,
  clone,
  isoDateToEuroDate,
  searchAsEuroDate,
} from "vue-dataset/docs/.vuepress/utilities";
import { debounce } from "vue-dataset/src/helpers";

export default {
  name: "EventsList",
  props: [
    "client_name",
    "filter_buttons",
    "events",
    "currency",
    "images_folder",
    "sub_title",
  ],
  data() {
    return {
      onlineFilter: "",
      selected: 5,
      startsWith: "",
      eventAsc: true,
      event_id: null,
      datasetI18n: {
        show: "Show",
        entries: "entries",
        previous: "<",
        next: ">",
        showing: "Showing",
        showingTo: "to",
        showingOf: "of",
        showingEntries: "entries",
      },
      swal_confirm_button_class: "",
      swal_container_class: "",
    };
  },
  mounted() {
    if (this.client_name == "DY") {
      this.swal_confirm_button_class =
        "btn btn-bumblebee btn-doomyoga  btn-doomyoga-primary";
      this.swal_container_class = "swal-container-dy";
    }
  },
  created() {
    this.startWithInput = debounce((e) => {
      this.startsWith = e.target.value;
    }, 100);
  },
  methods: {
    filterList,
    isoDateToEuroDate,
    searchAsEuroDate,
    updateData() {
      const updatedEvents = clone(events).slice(5, 5);
      this.events = updatedEvents;
    },
    startsWithFilter(value) {
      return value.toLowerCase().startsWith(this.startsWith.toLowerCase());
    },
    getImgUrl(file_name) {
      // var images = require.context('@/assets/images', false, /\.png$/);
      // return images('./' + file_name + ".png")
      return require("@/assets/images/" + file_name + ".png");
    },

    deleteEvent(id) {
      console.log("delete event ", id);
      this.event_id = id;
      this.$root.$emit("bv::show::modal", "deleteModal");
    },
    clickConfirmDelete() {
      // let formData = new FormData();
      // formData.append("event_id", $("#deleteModal #event_id").val());
      let eventId = $("#deleteModal #event_id").val();
      let client = $("#deleteModal #client").val();

      console.log("delete event ", eventId, client);

      axios
        .delete("event/events/" + eventId, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: client,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          this.$fire({
            // title: "Title",
            text: "Event is deleted successfully.",
            type: "success",
            timer: 5000,
            customClass: {
              container: this.swal_container_class,
              confirmButton: this.swal_confirm_button_class,
            },
          }).then((r) => {
            // console.log(r.value);
          });
          this.$bvModal.hide("deleteModal");
          this.$parent.getEventsList();
          // this.$router.go();
          // this.events = response.data.events;
        })
        .catch((error) => {
          console.log(error.response.data.error);
          console.log(error.request);
          console.log(error.message);
          this.$fire({
            // title: "Title",
            text: error.response.data.error,
            type: "error",
            // timer: 5000,
            customClass: {
              container: this.swal_container_class,
              confirmButton: this.swal_confirm_button_class,
            },
          }).then((r) => {
            // console.log(r.value);
          });
          // this.loginErrorMessage = error.response.data.error;
          // this.showLoginErrorMessage = true;
        });
    },
    closeModalDelete() {
      this.$bvModal.hide("deleteModal");
    },

    displayEvent(id) {
      console.log("display event ", id);
      this.event_id = id;
      this.$root.$emit("bv::show::modal", "displayModal");
    },
    clickConfirmDisplay() {
      let eventId = $("#displayModal #event_id").val();
      let client = $("#displayModal #client").val();

      console.log("display event ", eventId, client);

      let formData = new FormData();
      formData.append("is_hidden", 0);
      console.log(formData.get("is_hidden"));
      let temp = this;
      axios
        .post("event/events/visibility/" + eventId, formData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: client,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          this.$fire({
            // title: "Title",
            text: response.data.success,
            type: "success",
            timer: 5000,
            customClass: {
              container: this.swal_container_class,
              confirmButton: this.swal_confirm_button_class,
            },
          }).then((r) => {
            // console.log(r.value);
          });
           this.$bvModal.hide("displayModal");
           this.$parent.getEventsList();
          // this.$router.go();
          // this.events = response.data.events;
        })
        .catch((error) => {
          console.log(error.response.data.error);
          console.log(error.request);
          console.log(error.message);
          this.$fire({
            // title: "Title",
            text: error.response.data.error,
            type: "error",
            customClass: {
              container: this.swal_container_class,
              confirmButton: this.swal_confirm_button_class,
            },
            // timer: 5000,
          }).then((r) => {
            // console.log(r.value);
          });
          // this.loginErrorMessage = error.response.data.error;
          // this.showLoginErrorMessage = true;
        });
    },
    closeModalDisplay() {
      this.$bvModal.hide("displayModal");
    },

    hideEvent(id) {
      console.log("hide event ", id);
      this.event_id = id;
      // $('#hideModal #event_id').val(id);
      this.$root.$emit("bv::show::modal", "hideModal");
    },
    clickConfirmHide() {
      let eventId = $("#hideModal #event_id").val();
      let client = $("#hideModal #client").val();

      console.log("hide event ", eventId, client);

      let formDataa = new FormData();
      formDataa.append("is_hidden", 1);
      console.log(formDataa.get("is_hidden"));
      axios
        .post("event/events/visibility/" + eventId, formDataa, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: client,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          this.$fire({
            // title: "Title",
            text: response.data.success,
            type: "success",
            timer: 5000,
            customClass: {
              container: this.swal_container_class,
              confirmButton: this.swal_confirm_button_class,
            },
          }).then((r) => {
            // console.log(r.value);
          });
          this.$bvModal.hide("hideModal");
          this.$parent.getEventsList();
          // this.$router.go();
          // this.events = response.data.events;
        })
        .catch((error) => {
          console.log(error.response.data.error);
          console.log(error.request);
          console.log(error.message);
          this.$fire({
            // title: "Title",
            text: error.response.data.error,
            type: "error",
            // timer: 5000,
            customClass: {
              container: this.swal_container_class,
              confirmButton: this.swal_confirm_button_class,
            },
          }).then((r) => {
            // console.log(r.value);
          });
          // this.loginErrorMessage = error.response.data.error;
          // this.showLoginErrorMessage = true;
        });
    },
    closeModalHide() {
      this.$bvModal.hide("hideModal");
    },
    editEvent(id, type) {
      console.log("edit event", id, type);
      if (this.client_name === "DY") {
        if (type === "class") {
          this.$router.push({ name: "DoomYogaEditEventClass", params: { id } });
        } else if (type === "course") {
          this.$router.push({
            name: "DoomYogaEditEventCourse",
            params: { id },
          });
        } else if (type === "private_class") {
          this.$router.push({
            name: "DoomYogaEditEventPrivateClass",
            params: { id },
          });
        }
      } else if (this.client_name === "MID") {
        this.$router.push({ name: "MIDEditEvent", params: { id } });
      }
      // this.$router.push({ name: "DoOmYogaDashboard" });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/events/List.vue